import { all, fork, put, takeEvery } from 'redux-saga/effects';
import * as types from './types';
import * as Api from '../../api/projectTemplates';
import callToAPI from '../../../utils/callToAPI';
import ProjectTemplate from '../../../models/Template';

function* getProjectTemplates({ payload }) {
  yield callToAPI({
    apiCall: Api.getProjectTemplates,
    successResponseCode: 200,
    errorType: types.GET_PROJECT_TEMPLATES_ERROR,
    *callback({ data }) {
      yield put({
        type: types.GET_PROJECT_TEMPLATES_SUCCESS,
        payload: {
          projectTemplates: data.data.map((projectTemplate) => {
            return new ProjectTemplate(projectTemplate);
          }),
          total: data.total,
        },
      });
    },
    payload,
  });
}

function* updateProjectTemplate({ payload }) {
  yield callToAPI({
    apiCall: Api.updateProjectTemplate,
    successResponseCode: 200,
    errorType: types.UPDATE_PROJECT_TEMPLATE_ERROR,
    *callback(response) {
      yield put({
        type: types.UPDATE_PROJECT_TEMPLATE_SUCCESS,
        payload: new ProjectTemplate(response.data),
      });
    },
    payload,
  });
}

function* createProjectTemplate({ payload }) {
  yield callToAPI({
    apiCall: Api.createProjectTemplate,
    successResponseCode: 200,
    errorType: types.CREATE_PROJECT_TEMPLATE_ERROR,
    *callback(response) {
      yield put({
        type: types.CREATE_PROJECT_TEMPLATE_SUCCESS,
        payload: new ProjectTemplate(response.data),
      });
    },
    payload,
  });
}

function* deleteProjectTemplate({ payload }) {
  yield callToAPI({
    apiCall: Api.deleteProjectTemplate,
    successResponseCode: 200,
    errorType: types.DELETE_PROJECT_TEMPLATE_ERROR,
    *callback() {
      yield put({ type: types.DELETE_PROJECT_TEMPLATE_SUCCESS, payload });
    },
    payload,
  });
}

/* watchers */
function* watcherUpdateProjectTemplate() {
  yield takeEvery(types.UPDATE_PROJECT_TEMPLATE_REQUEST, updateProjectTemplate);
}

function* watcherGetProjectTemplates() {
  yield takeEvery(types.GET_PROJECT_TEMPLATES_REQUEST, getProjectTemplates);
}

function* watcherCreateProjectTemplate() {
  yield takeEvery(types.CREATE_PROJECT_TEMPLATE_REQUEST, createProjectTemplate);
}

function* watcherDeleteProjectTemplate() {
  yield takeEvery(types.DELETE_PROJECT_TEMPLATE_REQUEST, deleteProjectTemplate);
}

export default function* rootSaga() {
  yield all([
    fork(watcherUpdateProjectTemplate),
    fork(watcherGetProjectTemplates),
    fork(watcherCreateProjectTemplate),
    fork(watcherDeleteProjectTemplate),
  ]);
}
